import { StyleSheet, View } from "react-native";
import { Box } from "../components/Box";
import { Button } from "../components/Button";
import { Icon } from "../components/Icon";
import { Space } from "../components/Space";
import { Text } from "../components/Text";
import { ColorVariant, animDuration, colors, invariantColor } from "../utils/design";

const styles = StyleSheet.create({
  square1: {
    position: "absolute",
    width: 124,
    height: 124,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 16,
    transform: "rotate(0deg) translateX(0px)",
    animationKeyframes: {
      "0%": { transform: "rotate(0deg) translateX(0px)" },
      "40%": { transform: "rotate(-15deg) translateX(-17px)" },
      "100%": { transform: "rotate(-10deg) translateX(-12px)" },
    },
    animationFillMode: "forwards",
    animationDuration: animDuration[500],
  },
  square2: {
    width: 124,
    height: 124,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 16,
    transform: "rotate(0deg) translateX(0px)",
    animationKeyframes: {
      "0%": { transform: "rotate(0deg) translateX(0px)" },
      "100%": { transform: "rotate(10deg) translateX(12px)" },
    },
    animationFillMode: "forwards",
    animationDuration: animDuration[500],
    animationDelay: animDuration[200],

    boxShadow: [
      "-4px 4px 13px 0px rgba(0, 0, 0, 0.1)",
      "-18px 16px 24px 0px rgba(0, 0, 0, 0.09)",
      "-40px 35px 32px 0px rgba(0, 0, 0, 0.05)",
      "-71px 63px 38px 0px rgba(0, 0, 0, 0.01)",
      "-111px 99px 42px 0px rgba(0, 0, 0, 0)",
    ].join(","),
  },

  completedButton: {
    minWidth: 152,
  },
});

type Props = {
  variant: Exclude<ColorVariant, "neutral">;
  icon: IconName;
  title: string;
  description: React.ReactNode;
  submitText: string;
  onSubmit: () => void;
};

export const IconPage: React.FC<Props> = ({
  variant,
  icon,
  title,
  description,
  submitText,
  onSubmit,
}) => {
  return (
    <Box direction="column" alignItems="center">
      <Box direction="column" alignItems="center">
        <View style={[styles.square1, { backgroundColor: colors[variant][700] }]} />
        <View style={[styles.square2, { backgroundColor: colors[variant][500] }]}>
          <Icon name={icon} size={70} color={colors.neutral[900]} />
        </View>
      </Box>

      <Space height={54} />

      <Text variant="title2" align="center" color={invariantColor.white}>
        {title}
      </Text>
      <Space height={8} />
      <Text variant="small" align="center">
        {description}
      </Text>
      <Space height={24} />

      <Button style={styles.completedButton} onPress={onSubmit}>
        {submitText}
      </Button>
    </Box>
  );
};
